module.exports = __webpack_public_path__ + "img/cancel-gray-icon.0cc71d56.svg";